import { Injectable } from "@angular/core";
import { Cartao } from "@tivic-team/manager-ts/dist/mob/entities/cartao.entity";
import { CartaoController } from "app/controllers/mob/cartao.controller";
import { HttpFilter } from "sol-request-angular/dist/comunicacao";
import { Equal } from "sol-request-angular/dist/comunicacao/filter/Equal";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { ApiService } from "../api-service.interface";
import { LoaderService } from "../loader.service";
import { SituacaoDocumentoSearch } from "../ptc/situacao-documento.search";
import { CartaoSearch } from "./cartao.search";

@Injectable()
export class CartaoService implements ApiService<Cartao> {

    constructor(
        private _cartaoController: CartaoController,
        private _loaderService: LoaderService
    ) { }
    get(...args: number[]): Promise<Cartao> {
        throw new Error("Method not implemented.");
    }
    create(entity: Cartao): Promise<Cartao> {
        throw new Error("Method not implemented.");
    }
    update(entity: Cartao): Promise<Cartao> {
        throw new Error("Method not implemented.");
    }

    async find(cartaoSearch?: SituacaoDocumentoSearch):Promise<Cartao[]>{
        this._loaderService.show()
        return await this._cartaoController.find(cartaoSearch && cartaoSearch.getFilters() || null).finally(() => this._loaderService.hide());
    }
    

    async findCartoes(cartaoSearch?: CartaoSearch): Promise<Array<Cartao>> {
        this._loaderService.show()
        return await this._cartaoController.findCartoes(cartaoSearch && cartaoSearch.getFilters() || null).finally( () => this._loaderService.hide()); 
    }
    
    async generateReport(cartaoSearch?: CartaoSearch): Promise<Blob> {
        this._loaderService.show()
        try {
            return await this._cartaoController.generateReport(cartaoSearch && cartaoSearch.getFilters() || null).finally( () => this._loaderService.hide()); 
        }
        catch (error) { 
            this._loaderService.hide()
            return null; 
        }
    }

    async findCartao(cartaoSearch?: CartaoSearch): Promise<Array<Cartao>> {
        this._loaderService.show()
        try {
            return await this._cartaoController.findCartao(cartaoSearch && cartaoSearch.getFilters() || null).finally( () => this._loaderService.hide()); 
        }
        catch (error) { 
            this._loaderService.hide()
            return null; 
        }
    }
    
    async gerarRelatorio(cartaoSearch?: CartaoSearch): Promise<Blob> {
        this._loaderService.show()
        try {
            return await this._cartaoController.gerarRelatorio(cartaoSearch && cartaoSearch.getFilters() || null).finally( () => this._loaderService.hide()); 
        }
        catch (error) { 
            this._loaderService.hide()
            return null; 
        }
    }

    async getEstatistica(inicio:string, fim:string, relacao:string, agrupamento?:string):Promise<any> {
        let filtros:IFilter = new HttpFilter([]);

        if(inicio)
            filtros.addFilter(new Equal('inicio', inicio));

        if(fim)
            filtros.addFilter(new Equal('fim', fim));

        if(relacao)
            filtros.addFilter(new Equal('relacao', relacao));

        if(agrupamento)
            filtros.addFilter(new Equal('agrupamento', agrupamento));

        this._loaderService.show();
        return this._cartaoController.getEstatistica(filtros).finally(() => this._loaderService.hide());
    }

    async relatorio(cartaoSearch?: CartaoSearch): Promise<Blob> {
        this._loaderService.show()
        try {
            return await this._cartaoController.relatorio(cartaoSearch && cartaoSearch.getFilters() || null).finally( () => this._loaderService.hide()); 
        }
        catch (error) { 
            this._loaderService.hide()
            return null; 
        }
    }

    async relatorioCids(cartaoSearch?: CartaoSearch): Promise<Blob> {
        this._loaderService.show()
        return await this._cartaoController.relatorioCids(cartaoSearch && cartaoSearch.getFilters() || null).finally( () => this._loaderService.hide()); 
    }

    async relatorioProcessoAnual(cartaoSearch?: SituacaoDocumentoSearch): Promise<Blob>{
        this._loaderService.show();
        try{
            return await this._cartaoController.relatorioProcessoAnual((cartaoSearch && cartaoSearch.getFilters()) || null).finally(() => this._loaderService.hide()); 
        } catch(error) {
            this._loaderService.hide()
            console.log(error);
            return null;
        }
    }
}